import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

// Hududlar (Viloyat -> Shahar/Tuman -> Zona) — Nastroyka daraxti.
// Backend yassi ro'yxat qaytaradi (parent_id bilan), shu yerda daraxtga aylantiramiz.
function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])                 // yassi ro'yxat
	const [expanded, setExpanded] = useState({})         // { [id]: true }
	const [showModal, setShowModal] = useState(false)
	const [item, setItem] = useState({})                 // {id?, name, type, parent_id, parentName}
	const [modalDelete, setModalDelete] = useState({ show: false })

	const typeLabel = { viloyat: t('region_type_viloyat'), tuman: t('region_type_tuman'), zona: t('region_type_zona') }
	const typeBadge = { viloyat: 'bg-primary', tuman: 'bg-info', zona: 'bg-secondary' }

	async function load() {
		const res = await GET('/regions', {}, { loader: true })
		if (httpOk(res)) {
			setData(res.data)
			// Viloyatlarni sukut bo'yicha ochamiz
			setExpanded(prev => {
				const next = { ...prev }
				res.data.forEach(r => { if (r.type === 'viloyat' && next[r.id] === undefined) next[r.id] = true })
				return next
			})
		}
	}

	useEffect(() => { load() }, []) // eslint-disable-line react-hooks/exhaustive-deps

	// Yassi ro'yxatdan daraxt
	function buildTree(list) {
		const byId = {}
		list.forEach(r => { byId[r.id] = { ...r, children: [] } })
		const roots = []
		list.forEach(r => {
			if (r.parent_id && byId[r.parent_id]) byId[r.parent_id].children.push(byId[r.id])
			else roots.push(byId[r.id])
		})
		return roots
	}

	function toggle(id) {
		setExpanded({ ...expanded, [id]: !expanded[id] })
	}

	function openAdd(parent) {
		if (!parent) setItem({ name: '', type: 'viloyat', parent_id: null })
		else if (parent.type === 'viloyat') setItem({ name: '', type: 'tuman', parent_id: parent.id, parentName: parent.name })
		else setItem({ name: '', type: 'zona', parent_id: parent.id, parentName: parent.name })
		setShowModal(true)
	}

	function openEdit(node) {
		setItem({ id: node.id, name: node.name, type: node.type })
		setShowModal(true)
	}

	async function save(e) {
		e.preventDefault()
		if (!(item.name || '').trim()) return

		let res
		if (item.id) res = await PUT('/regions', { id: item.id, name: item.name }, { loader: true })
		else res = await POST('/regions', { name: item.name, type: item.type, parent_id: item.parent_id }, { loader: true })

		if (httpOk(res)) {
			setShowModal(false)
			load()
		}
	}

	async function deleteItem() {
		const res = await DELETE('/regions', { id: modalDelete.id }, { loader: true })
		if (httpOk(res)) {
			setModalDelete({ show: false })
			load()
		}
	}

	// Bitta daraxt shoxini chizish (rekursiv)
	function renderNode(node, depth) {
		const hasChildren = node.children && node.children.length > 0
		const isOpen = !!expanded[node.id]
		return (
			<React.Fragment key={node.id}>
				<div className="d-flex align-items-center region-row"
					style={{ paddingLeft: `${depth * 26 + 8}px`, borderBottom: '1px solid #f1f5f9', minHeight: '46px' }}>
					<span style={{ width: '24px', cursor: hasChildren ? 'pointer' : 'default', color: '#94a3b8' }}
						onClick={() => hasChildren && toggle(node.id)}>
						{hasChildren && <i className={`uil ${isOpen ? 'uil-angle-down' : 'uil-angle-right'}`}></i>}
					</span>
					<span className="fw-600" style={{ fontSize: node.type === 'zona' ? '13px' : '14px', color: node.type === 'zona' ? '#475569' : '#0f172a' }}>
						{node.name}
					</span>
					<span className={`badge ${typeBadge[node.type]} ms-2`} style={{ fontSize: '10px', fontWeight: 600 }}>
						{typeLabel[node.type]}
					</span>
					{node.client_count > 0 &&
						<span className="badge bg-light text-dark ms-2" style={{ fontSize: '11px' }}>
							{node.client_count} {t('region_clients')}
						</span>
					}
					<div className="ms-auto d-flex gap-1 pe-2">
						{node.type !== 'zona' &&
							<button className="btn btn-sm btn-outline-primary py-0 px-1" title={t('add')}
								onClick={() => openAdd(node)} style={{ lineHeight: 1 }}>
								<i className="uil-plus"></i>
							</button>
						}
						<button className="btn btn-sm btn-outline-secondary py-0 px-1" title={t('edit')}
							onClick={() => openEdit(node)} style={{ lineHeight: 1 }}>
							<i className="uil-edit-alt"></i>
						</button>
						<button className="btn btn-sm btn-outline-danger py-0 px-1" title={t('delete')}
							onClick={() => setModalDelete({ show: true, id: node.id, name: node.name })} style={{ lineHeight: 1 }}>
							<i className="uil-trash-alt"></i>
						</button>
					</div>
				</div>
				{hasChildren && isOpen && node.children.map(child => renderNode(child, depth + 1))}
			</React.Fragment>
		)
	}

	const tree = buildTree(data)

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('regions')} [{data.length}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary" onClick={() => openAdd(null)}>
						<i className="uil-plus me-1"></i>{t('region_add_viloyat')}
					</button>
				</div>
			</div>

			<div className="row">
				<div className="col-md-8 col-lg-7">
					<div className="card">
						<div className="card-body p-0">
							{tree.length === 0 &&
								<div className="text-center text-muted py-5">
									<i className="uil-map-marker" style={{ fontSize: '32px', opacity: .4 }}></i>
									<div className="mt-2">{t('list_empty')}</div>
								</div>
							}
							{tree.map(node => renderNode(node, 0))}
						</div>
					</div>
					<p className="text-muted" style={{ fontSize: '12.5px' }}>
						<i className="uil-info-circle me-1"></i>
						{t('region_hint')}
					</p>
				</div>
			</div>

			{/* MODAL — qo'shish / tahrirlash */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{item.id ? t('edit') : (typeLabel[item.type] || '') + ' — ' + t('add')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={save} autoComplete="off">
						{item.parentName &&
							<div className="mb-2 text-muted" style={{ fontSize: '13px' }}>
								<i className="uil-map-marker me-1"></i>{item.parentName} <i className="uil-angle-right"></i> {typeLabel[item.type]}
							</div>
						}
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name" autoFocus
								value={item.name ?? ""}
								onChange={(e) => setItem({ ...item, 'name': e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => setShowModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			{/* MODAL — o'chirish tasdig'i */}
			<Modal show={modalDelete.show} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => setModalDelete({ show: false })}>
				<Modal.Body>
					<div className="text-center py-2">
						<i className="uil-trash-alt text-danger" style={{ fontSize: '34px' }}></i>
						<h5 className="mt-2">{modalDelete.name}</h5>
						<p className="text-muted">{t('region_delete_q')}</p>
					</div>
					<div className="d-flex gap-2 w-100">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => setModalDelete({ show: false })}>{t('cancel')}</button>
						<button type="button" className="btn btn-danger w-100" onClick={deleteItem}>{t('delete')}</button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
